import { QuestionCircleOutlined } from '@ant-design/icons';
import { Space, theme, Typography } from 'antd';
import styles from './header.module.less';
import { GET_HELP_BUTTON_TRACKING_ID } from '@copilot/common/tracking/userpilotEventConsts';
import { Config } from '@copilot/common/config';
import { isEmpty } from 'lodash';

const { useToken } = theme;

type SupportDropdownPropsType = {
    /**
     * Whether the support dropdown should be rendered in light or dark mode
     */
    isDark?: boolean;
};

/**
 * Initialize the Get Help button that triggers the Userpilot Resource Center.
 * The button is not shown on reseller/white label sites.
 *
 * @constructor
 */
export function SupportDropdown(props: SupportDropdownPropsType) {
    const { isDark } = props;
    const { token } = useToken();

    // Hide the Get Help button on reseller/white label sites
    if (isEmpty(Config.userPilotResourceCenterId)) {
        return null;
    }

    const handleGetHelpClick = () => {
        // Trigger the Userpilot Resource Center
        if (window.userpilot) {
            window.userpilot.trigger(`resource_center:${Config.userPilotResourceCenterId}`);
        }
    };

    return (
        <Space
            className={isDark ? styles.supportButtonDark : styles.supportButtonLight}
            tabIndex={2}
            onClick={handleGetHelpClick}
            data-tracking-id={GET_HELP_BUTTON_TRACKING_ID}
        >
            <QuestionCircleOutlined
                style={{ verticalAlign: 'middle', fontSize: token.fontSizeLG }}
            />
            <Typography.Text>Get Help</Typography.Text>
        </Space>
    );
}
